function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#020202}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M87.2 174.7c0-21.2-1.3-41.7-3.3-62.9h94.6l3.3 43c10.6-14.5 36.4-50.3 103.2-50.3 76.8 0 98.6 47 105.2 62.9 27.8-53.6 72.8-62.2 107.2-62.2 67.5 0 94.7 40.4 101.9 53.6 17.9 29.1 16.5 69.5 16.5 98.6v183.1h-98.6v-191c0-35.8-5.3-75.5-56.3-75.5-58.6 0-59.9 55-59.9 104.6v161.9h-98.6v-193c0-25.8-.7-73.5-54.9-73.5-61.6 0-61.6 53-61.6 75.5v191H87.2V174.7zM83.9 514h532.2v81.5H83.9V514z"
});

function SvgMstableSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 700 700",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMstableSmall);
export default __webpack_public_path__ + "static/media/mstable-small.a97910ff.svg";
export { ForwardRef as ReactComponent };